<template>
    <div id="footer">
    	<div class="footers">
        <div class="footer_head">
        <div class="footer_left">
            <div>
                <img src="https://blh01.oss-cn-shanghai.aliyuncs.com/officialWeb/android.png" alt="">
                <p>安卓下载</p>
            </div>
            <div>
                <img src="https://blh01.oss-cn-shanghai.aliyuncs.com/officialWeb/IOS.png" alt="">
                <p>IOS下载</p>
            </div>
        </div>
        <div class="footer_right">
            <ul class="footer_right_info">
                <li>
                    <p class="title">爱车养护</p>
                </li>
                <li @click="toTop">
                    <router-link to="/love/6/6">汇悦套餐</router-link>
                </li>
                <li @click="toTop">
                    <router-link to="/love/1/1" >汽车营养液</router-link>                  
                </li>
                <li>
                    <router-link to="/love/2/2">水循环护理液</router-link>
                </li @click="toTop">
                <!--<li>
                    <router-link to="">新人专享</router-link>
                </li>
                <li>
                    <router-link to="">公益套餐</router-link>
                </li>-->
                <li @click="toTop">
                    <router-link to="/love/3/3">速弘全合成润滑油</router-link>
                </li>
            </ul>
            <ul class="footer_right_info">
                <li>
                    <p class="title">关于百路汇</p>
                </li>
                <li @click="toTop">
                    <router-link to="/about/1/1">公司介绍</router-link>                  
                </li>
                <li @click="toTop">
                    <router-link to="/about/2/2">企业形象</router-link>
                </li>
                <li @click="toTop">
                    <router-link to="/about/3/3">新闻公告</router-link>
                </li>
                <li @click="toTop">
                    <router-link to="/about/4/4">商务合作</router-link>
                </li>
            </ul>
            <ul class="footer_right_info">
                <li>
                    <p class="title">公益使者</p>
                </li>
                <li @click="toTop">
                    <router-link to="/good/1/1">公益使者介绍</router-link>                  
                </li>
                <li @click="toTop">
                    <router-link to="/good/2/2">风采人物</router-link>
                </li>
                <li @click="toTop">
                    <router-link to="/good/3/3">加入公益使者</router-link>
                </li>
            </ul>
            <ul class="footer_right_info">
                <li>
                    <p class="title">联盟服务商</p>
                </li>
                <li @click="toTop">
                    <router-link to="/alliance/1/1">联盟服务商介绍</router-link>                  
                </li>
                <li @click="toTop">
                    <router-link to="/alliance/2/2">加入联盟服务商</router-link>
                </li>
            </ul>
            <ul class="footer_right_info">
                <li>
                    <p class="title">客服中心</p>
                </li>
                <li @click="toTop">
                    <router-link to="/service/1/1" >联系我们</router-link>                  
                </li>
                <li @click="toTop">
                    <router-link to="/service/2/2">常见问题</router-link>
                </li>
                 <li @click="toTop">
                    <router-link to="/service/3/3">意见反馈</router-link>
                </li>
            </ul>
        </div>
       
        </div>
        <div class="contact">
            <div class="phone">
                <img src="https://blh01.oss-cn-shanghai.aliyuncs.com/officialWeb/phone.png" alt="">
                <span class="phone_num">400-8282-966</span>
            </div>
            <div class="address">
                <img src="https://blh01.oss-cn-shanghai.aliyuncs.com/officialWeb/address.png" alt="">
                <span>南京市紫东路2号紫东国际创意园C1栋</span>
            </div>
        </div>
        <p class="copyright"><a href="http://www.beian.miit.gov.cn">苏ICP备17006620-1</a>增值电信业务经营许可证苏B2-20170183 百路汇电子商务有限责任公司版权所有</p>
        </div>
    </div>
</template>
<script>
export default {
        name: "top-top",
        data(){
            return{
                toTopIsShow:false//控制回到顶部按钮是否显示
            }
        },
        methods:{
            toTop(){
                if(document.documentElement.scrollTop>0){
                    document.documentElement.scrollTop=0;
                }
            }
        }
}
</script>
<style>
    #footer{
        padding: 50px 200px;
        background: #3E4147;
        color:#fff;
        overflow: hidden;
        height: 250px;
    }
    #footer a{
        color:#fff;
        font-size: 15px;        
    }
   #footer .footer_head,.contact{
        display: flex;
    }
   #footer .footer_left{
        text-align: center;
        font-size: 14px;
    }
   #footer .footer_left div:nth-child(1){
        margin-bottom:20px;
    }
   #footer .footer_left img{
        width: 100px;
    }
   #footer .footer_right{
        display: flex;
    }
   #footer .title{
        margin-bottom: 8px;
        width: 120px;
        font-size: 16px; 
    }
   #footer .footer_right_info{
        margin-left: 90px;
    }
   #footer .footer_right_info li{
        margin-bottom: 2px;
        /*text-align: center;*/
    }
   #footer .contact,.copyright{
        margin-left: 200px;
        margin-top: -70px;
        height: 125px;
    }
   #footer .phone{
        line-height: 44px;
        color: #e70012;
    }
   #footer .contact img{
        vertical-align: -10px;
    }
   #footer .address{
        margin-left: 30px;
    }
    #footer .phone_num{
    	width: 100px;
    }
    #footer .footers{
    	
    }
</style>





// WEBPACK FOOTER //
// src/components/common/footer.vue